export const subscriptionKeys = {
    all: ['subscriptions'] as const,
    lists: () => [...subscriptionKeys.all, 'list'] as const,
    details: (id: string) => [...subscriptionKeys.all, 'details', id] as const,
  };